export default __webpack_public_path__ + "static/media/circled_me.bc89867f.png";